// extracted by mini-css-extract-plugin
export default {"logoDiv":"signin_logoDiv__249jh","companyLogo":"signin_companyLogo__PjGTV","googleIcon":"signin_googleIcon__+0UVT","box":"signin_box__qF3Fc"};